/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export type HandledError = {
  error: any;
  silent: boolean;
  source: ErrorSource;
};

export type ErrorSource = 'effect' | 'STOMP' | 'angular-error-handler' | 'global';

@Injectable({ providedIn: 'root' })
export class ErrorSincService implements OnDestroy {
  private errors$ = new Subject<HandledError>();
  public injestError(error: any, params: { silent: boolean; source: ErrorSource }) {
    this.errors$.next({ error, silent: params.silent, source: params.source });
  }
  public subscribe() {
    return this.errors$.asObservable();
  }
  ngOnDestroy(): void {
    this.errors$.complete();
  }
}
